import { render, staticRenderFns } from "./DeliveryMethodDetails.vue?vue&type=template&id=548a0918&scoped=true&"
import script from "./DeliveryMethodDetails.vue?vue&type=script&lang=js&"
export * from "./DeliveryMethodDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548a0918",
  null
  
)

export default component.exports